export default "__VITE_ASSET__CwUzMl5a__"